// @flow

import * as React from 'react';

import styles from './ReviewCount.module.scss';

import FontAwesomeIcon, {
  regularComment
} from 'common/components/FontAwesomeIcon';

type Props = {|
  reviewCount: number
|};

export default function ReviewCount({ reviewCount }: Props): React.Node {
  return (
    reviewCount > 0 && (
      <span className={styles.reviewCount}>
        <FontAwesomeIcon className={styles.icon} icon={regularComment} />
        {reviewCount}
      </span>
    )
  );
}
